import { z } from 'zod';

export const sseContract = z.object({
  namespace: z.literal('/api'),
  pathPrefix: z.literal('/:tenantId/sse/'),
  response: z.object({
    content: z.string(),
    id: z.string(),
    timestamp: z.number(),
  }),
  paths: z.object({
    chatInsightsWithCitations: z.object({
      path: z.literal('insights-with-citations'),
      params: z.object({
        tenantId: z.string(),
      }),
      body: z.object({
        message: z.object({
          content: z.string(),
        }),
        threadId: z.string().optional(),
        patientId: z.string().optional(),
      }),
    }),
  }),
});

type SseContract = z.infer<typeof sseContract>;
export type SseKeys = keyof SseContract['paths'];

export const getSseFullPath = (route: SseKeys) =>
  `${sseContract.shape.pathPrefix.value}${sseContract.shape.paths.shape[route].shape.path.value}`;

export const getEndpointUrl = <T extends SseKeys>(
  baseUrl: string,
  route: T,
  args?: { params: SseContract['paths'][T]['params'] },
): string => {
  const params = args?.params;
  const schema = sseContract.shape.paths.shape[route];
  let path = `${sseContract.shape.namespace.value}${sseContract.shape.pathPrefix.value}${schema.shape.path.value}`;
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      path = path.replace(`:${key}`, String(value));
    }
  }
  return `${baseUrl}${path}`;
};
